import { IBookAllParticipantsToCourseExecutionActionPayload } from '../interfaces/book-all-participants-to-course-execution.action.payload.interface';

export class BookAllParticipantsToCourseExecutionCommand {
    course_execution_ids: number[];

    constructor(query: IBookAllParticipantsToCourseExecutionActionPayload) {
        this.course_execution_ids = query.course_execution_ids.map((moduleId) => Number(moduleId));
    }
}
